import { GoPencil } from "react-icons/go";
import { Button } from "../../../../../components";
import { useEffect, useState } from "react";

const NudgeOptions = ({ nudgeData = {}, activeButton, handleNudgeOptionClick, userPersonaKey, customizeState }) => {
    const [isLeadCapture, setIsLeadCapture] = useState(false);
    const [leadCaptureViewFields, setLeadCaptureViewFields] = useState([]);

    useEffect(() => {
        setIsLeadCapture(userPersonaKey?.includes('leadCapturePersonaNudge') || false);
    }, [userPersonaKey]);

    useEffect(() => {
        if (isLeadCapture) {
            const viewMode = customizeState?.nudgeShowing?.view_mode;
            if (viewMode === "leadCaptureForm") {
                setLeadCaptureViewFields([
                    "nudge", "nudgeClosed", "nudgeCopyCode", "nudgeCouponCode", 
                    "nudgeDisclaimerText", "nudgeImages", "nudgeInputFields", 
                    "nudgeOfferText", "nudgePosition", "nudgeShowing", "nudgeTrafficSources", "nudgeDisclaimerText"
                ]);
            } else if (viewMode === "formSubmission") {
                setLeadCaptureViewFields([
                    "thankYouButton", "formSubmissionMedia", "thankYouOfferText", "nudgeShowing", "nudgeTrafficSources", "formSubmissionDisclaimerText"
                ]);
            } else {
                setLeadCaptureViewFields([]); // Clear fields if no valid view mode
            }
        } else {
            setLeadCaptureViewFields([]); // Clear fields if not a lead capture
        }
    }, [isLeadCapture, customizeState?.nudgeShowing?.view_mode]);

    return (
        <div className="customisableOptions lg:w-1/2 p-2">
            <div className="flex">
                <h3 className="mx-auto text-xl font-semibold">Customize nudge properties</h3>
            </div>
            <div className="options">
                {Object.entries(nudgeData)
                    .map(([entryName, entryValue], index) => {
                        if (entryName === 'nudgeTrafficSources') return null 
                        if(isLeadCapture && !leadCaptureViewFields.includes(entryName)) return null;
                        return (
                            <Option 
                                key={index} 
                                title={entryValue.optionName} 
                                value={entryValue} 
                                activeButton={activeButton} 
                                onClick={() => handleNudgeOptionClick(entryValue)} 
                            />
                        );
                    })
                }
            </div>
        </div>
    );
};

const Option = ({ title, value, activeButton, onClick }) => {
    return (
        <div className="option flex items-center justify-between mt-2 sm:px-5 ">
            <p className="optionHeading">{title}</p>
            <Button Icon={GoPencil} active={value.optionValue === activeButton} onClick={onClick} title="CUSTOMIZE" />
        </div>
    );
};

export default NudgeOptions;